import React from "react";
import Svg, { Path } from "react-native-svg";

const Verified = (props) => {
  const { color = "#fff", height = 14, width = 14 } = props;

  return (
    <Svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M8 0.833984L0.5 4.16732V9.16732C0.5 13.7923 3.7 18.1173 8 19.1673C12.3 18.1173 15.5 13.7923 15.5 9.16732V4.16732L8 0.833984ZM6.33333 14.1673L3 10.834L4.175 9.65899L6.33333 11.809L11.825 6.31732L13 7.50065L6.33333 14.1673Z"
        fill="#00AB59"
      />
    </Svg>
  );
};

export default Verified;
